import Immutable from 'immutable';
import { UPDATE_HTTP_STATUS } from '../actions/httpStatus';
import { UPDATE_NETWORK_STATUS, NETWORK_STATUS_ONLINE } from '../actions/networkStatus';

const NETWORK = 'network';
const HTTP_STATUS = 'httpStatus';
const NETWORK_STATUS = 'networkStatus';

export const initialState = Immutable.fromJS({
    httpStatus: null,
    networkStatus: NETWORK_STATUS_ONLINE,
});

export default function network(state = initialState, action) {
    switch (action.type) {
        case UPDATE_HTTP_STATUS:
            return state.setIn([HTTP_STATUS], action.payload);
        case UPDATE_NETWORK_STATUS:
            return state.setIn([NETWORK_STATUS], action.payload);
        default:
            return state;
    }
}

export const httpStatusSelector = (state) => state.getIn([NETWORK, HTTP_STATUS]);
export const networkOnlineSelector = (state) =>
    state.getIn([NETWORK, NETWORK_STATUS]) === NETWORK_STATUS_ONLINE;
